import { z } from 'zod';

const EnvSchema = z.object({
    REACT_APP_NODE_ENV: z.string({
        description: 'Node environment', 
        required_error: 'Add node environment'
    }),
    REACT_APP_GLOBAL_URL: z.string({
        description: 'Global url', 
        required_error: 'Add global url'
    }),
    REACT_APP_CLIENT_URL: z.string({
        description: 'Client url', 
        required_error: 'Add client url'
    }),
    REACT_APP_SCRAPER_URL: z.string({
        description: 'Scraper url', 
        required_error: 'Add scraper url'
    }),
    REACT_APP_GOOGLE_MAPS: z.string({
        description: 'Google maps', 
        required_error: 'Add google maps key'
    }),
    REACT_APP_AWS_CLOUDFLARE: z.string({
        description: 'Cloudflare url', 
        required_error: 'Add cloudflare url'
    }),
    REACT_APP_WHATSAPP_URL: z.string({
        description: 'Whatsapp url', 
        required_error: 'Add whatsapp url'
    }),
});

export const env = EnvSchema.parse(process.env);